import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { useStartDonationCount } from './-components/donation-count';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/www')({
	// No `head()`: `__root` declares and preloads Rethink Sans for every page in this app.
	component: RouteComponent,
	// For a `notFound()` from a page that exists (`/www/$` covers the rest); otherwise the root's PORTAL 404 renders.
	notFoundComponent: NotFoundComponent,
});

/** Wrapped in the provider for the same reason RouteComponent is — see the note inside it. */
function NotFoundComponent() {
	const { i18n } = Route.useRouteContext();
	return (
		<I18nProvider i18n={i18n}>
			<NotFoundPage />
		</I18nProvider>
	);
}

function RouteComponent() {
	// Request-scoped Lingui instance from router context — see $portalId/route.tsx.
	const { i18n } = Route.useRouteContext();
	// Started here so the Solutions odometer counts the whole visit, not just that page.
	useStartDonationCount();
	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
